
function CommentSVG() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.3332 14V0.666687H0.666504V14H5.6665L8.99984 17.3334L12.3332 14H17.3332ZM2.33317 2.33335H15.6665V12.3334H11.6428L8.99984 14.9759L6.35686 12.3334H2.33317V2.33335ZM13.1665 8.16669V9.83335H4.83317V8.16669H13.1665ZM13.1665 6.50002V4.83335H4.83317V6.50002H13.1665Z" fill="#2ABDBB"/>
    </svg>
  )
}

export { CommentSVG }